<template>
  <div class="g-site">
    <div class="g-site-content">
      <i class="icon iconfont icon-index"></i>
      <span @click="linkTo()">&nbsp;Your location：{{site}}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "g-nav",
  data() {
    return {
      routerArr: [
            { name: "Home", router: "/homeEn" },
        { name: "Product", router: "/ex-listEn",children: [
          {name:'展商详情',router:'/ex-detailsEn/'},
          {name:'产品详情',router:'/pro-detailsEn/'}
            ]
            },
         { name: "Exhibitor", router: "/ex-listEn2" },
        
        { name: "新品马拉松", router: "/act-listEn", children: [{name:'活动详情',router:'/activity-detailsEn/'}]},
        { name: "Matchmaking", router: "/chanceEn",children:[{name:'Details',router:'/chance-detailEn'}]},
        { name: "CMEF云课", router: "/pro-listEn" },
        { name: "Contact us", router: "/contactEn" },
        { name: "品牌展会", router: "/aboutEn" },
        { name: "New Products", router: "/act-xinpinhui" },
        { name: "Trending Products",router: "/act-zhenpinhui"  },
        // { name: "News", router: "/about" }
      ],
      site: "Home"
    };
  },
  watch: {
    $route(to, from) {
      this.setIndex();
    }
  },
  created() {
    this.setIndex();
  },
  methods: {
    setIndex() {
      this.routerArr.some((el, idx) => {
        const path = this.$router.history.current.path;
        const pathUrl = this.$route.name;
        if (path.search(el.router) !== -1) {
          if (el.name !== "Home") {
            this.site = "Home" + " > " + el.name;
          } else {
            this.site = el.name;
          }
        } 
        if (el.children && el.children.length) {
          el.children.forEach(c => {
            if (path.indexOf(c.router) !== -1) {
              this.site = "Home" + " > " + el.name + " > " + c.name;
            }
          });
        }
        if (pathUrl === "chance-typeEn") {
          this.site = "Home" + " > " + "Matchmaking" + " > " + this.$route.query.name;
        }
        if (pathUrl === "aboutEn") {
          this.site = "Home" + " > " + "Brand Exhibitions" + " > " + this.$route.query.name;
        }
        if (pathUrl === "newsEn") {
          if (this.$route.query.type === "0") {
            this.site = "Home" + " > " + "News" + " > " + "Industry News";
          }
          if (this.$route.query.type === "1") {
            this.site = "Home" + " > " + "News" + " > " + "Exhibitor News";
          }
        }
        if (pathUrl === "news-detailsEn") {
          this.site = "Home" + " > " + "News" + " > " + "Details";
        }
      });
    },
    linkTo() {
      this.$router.push("/homeEn");
    }
  }
};
</script>

<style lang="scss" scoped>
.g-site {
  width: 100%;
  font-size: 14px;
  &-content {
    width: 1200px;
    line-height: 1;
    margin: 0 auto;
    padding: 20px 0;
    display: flex;
    align-items: center;
    i {
      font-size: 20px;
      color: #db2a4b;
    }
    span {
      cursor: pointer;
    }
  }
}
</style>